<template>
  <div class="card">
    <div class="card-header">
      <h3 class="mb-0">Comments</h3>
    </div>

      <div class="">
        <div id="comment-card" ref="comment-card" v-if="hasComments" class="p-3 list-group">
          <comment v-for="comment in comments"
                   :key="comment.timestamp"
                   :comment="comment"
          />
        </div>
        <div v-else class="text-center p-3">
          No comments yet
        </div>

        <hr class="m-0">

        <div class="media-body m-3">
          <form>
            <b-form-textarea
              id="comment-input"
              class="form-control"
              v-model="newText"
              @keydown.enter.exact.prevent
              @keyup.enter.exact="commentSave"
              placeholder="Write a comment..."
              rows="2"
              max-rows="6"
            ></b-form-textarea>
          </form>
        </div>
      </div>
    <b-card-footer>
      <div class="d-flex p-2">
        <b-button variant="primary" size="sm" @click="commentSave" class="ml-auto">Send</b-button>
      </div>
      <b-form-invalid-feedback :state="errorMessage === undefined">
        {{errorMessage}}
      </b-form-invalid-feedback>
    </b-card-footer>
    </div>

</template>
<script>

import Comment from '#/ui/Components/Comment.vue';

import { CommentListRequest } from '#/protobuf/service_query_pb';
import { AddCommentRequest } from '#/protobuf/service_modification_pb';
import { CommentIngest } from '#/protobuf/comments_pb';
import { bus } from '#/toast/bus';

export default {
  components: {
    Comment,
  },
  props: {
    jobId: {
      type: String,
      required: false,
    },
    entityId: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      errorMessage: undefined,
      newText: '',
      comments: [],
    };
  },
  computed: {
    hasComments() {
      return this.comments && this.comments.length > 0;
    },
  },
  created() {
    // TODO: pagination
    bus.$on('comment_receiving', (comment) => {
      if (this.jobId) {
        this.comments.push(comment);
        setTimeout(() => {
          this.scrollToEnd();
        }, 100);
      } else if (this.entityId) {
        const newEntity = this.entityId.toObject();
        const size = newEntity.size.toString();
        const checksum = newEntity.checksum.toString();
        if (comment.entityId.size.toString() === size && comment.entityId.checksum === checksum) {
          this.comments.push(comment);
          setTimeout(() => {
            this.scrollToEnd();
          }, 100);
        }
      } else {
        console.warn('comment received but not associate with this job or entity');
      }
    });

    const request = new CommentListRequest();
    if (this.jobId) {
      request.setJobId(this.jobId);
    } else if (this.entityId) {
      request.setEntityId(this.entityId);
    } else {
      console.warn('error - comment card loaded without a job or entity id');
      return;
    }

    const commentPromise = this.$store.dispatch('comments/loadList', request);
    commentPromise.then((response) => {
      console.log('loaded comments ', response.toObject());
      response.getCommentsList().forEach((comment) => {
        console.log('comment', comment.getTimestamp(), comment.getText());
        this.comments.unshift(comment.toObject());
      });

      // Scrolling issue fixed with below code
      setTimeout(() => {
        this.scrollToEnd();
      }, 100);
    }).catch((error) => {
      console.log('promise rejected for comment list: ', error);
    });
  },
  mounted() {

  },
  methods: {
    commentSave() {
      if (!this.newText || this.newText.trim() === '') {
        console.warn('warning - cannot save empty comment');
        return;
      }
      console.log('comment saving...', this.newText);
      const request = new AddCommentRequest();
      const comment = new CommentIngest();
      if (this.jobId) {
        comment.setJobId(this.jobId);
      } else if (this.entityId) {
        comment.setEntityId(this.entityId);
      } else {
        console.warn('error - comment attempted to save without a job or entity id');
        return;
      }
      comment.setText(this.newText);
      request.setComment(comment);
      const savePromise = this.$store.dispatch('comments/addComment', request);

      savePromise.then((response) => {
        console.log('saved comment', response.toObject());
        this.newText = '';

        const responseComment = response.toObject().comment;
        // this is obviously our own comment,
        // lets add the user image to it here so we don't trigger unnecessary backend queries
        responseComment.userInfo.userPictureUrl = this.$store.getters['user/userPhoto'];
        this.comments.push(responseComment);

        // Comment card scrolling to bottom
        setTimeout(() => {
          this.scrollToEnd();
        }, 100);
      }).catch((error) => {
        console.error('promise rejected for save comment', error);
        this.errorMessage = error.message !== '' ? error.message : 'Whoops... Something went wrong.';
      });
    },
    scrollToEnd() {
      const elem = document.getElementById('comment-card');
      if (elem) {
        elem.scrollTop = elem.scrollHeight;
      }
    },
  },
};
</script>

<style scoped>
</style>
